var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#2F65CC",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 11.25H10C9.59 11.25 9.25 10.91 9.25 10.5C9.25 10.09 9.59 9.75 10 9.75H30C30.41 9.75 30.75 10.09 30.75 10.5C30.75 10.91 30.41 11.25 30 11.25Z",
    fill: "#2F65CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6719 10.5V22.47C11.6719 23.45 12.1319 24.38 12.9219 24.97L18.1319 28.87C19.2419 29.7 20.7719 29.7 21.8819 28.87L27.0919 24.97C27.8819 24.38 28.3419 23.45 28.3419 22.47V10.5H11.6719ZM24.0019 21.75H16.0019C15.5919 21.75 15.2519 21.41 15.2519 21C15.2519 20.59 15.5919 20.25 16.0019 20.25H24.0019C24.4119 20.25 24.7519 20.59 24.7519 21C24.7519 21.41 24.4119 21.75 24.0019 21.75ZM24.0019 16.75H16.0019C15.5919 16.75 15.2519 16.41 15.2519 16C15.2519 15.59 15.5919 15.25 16.0019 15.25H24.0019C24.4119 15.25 24.7519 15.59 24.7519 16C24.7519 16.41 24.4119 16.75 24.0019 16.75Z",
    fill: "#2F65CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.3d2309446415704c21479ae36b80ac4a.svg";
export { ForwardRef as ReactComponent };